// constants auth
export const authConstants = {
    LOGIN_SUCCES: "AUTH_LOGIN_SUCCES",
    LOGOUT_SUCCES: "AUTH_LOGOUT_SUCCES"
};

export const user_types = {
    GUEST: "GUEST",
    ECHIPA: "ECHIPA",
    ADMIN: "ADMIN"
}